import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-race-team-page',
  templateUrl: './race-team-page.component.html',
  styleUrls: ['./race-team-page.component.scss']
})
export class RaceTeamPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
